
export function VacationBanner(props) {
    if (!props.bannerData?.bannerActive || props.dismissed) return null;
    return (
        <div className="vacation-banner" role="alert">
            <div className="vacation-banner__icon">🏖️</div>
            <div className="vacation-banner__body">
                <div className="vacation-banner__title">{props.bannerData.title}</div>
                <div className="vacation-banner__text">
                    {props.bannerData.text && <span>{props.bannerData.text} </span>}
                    {props.bannerData.from && props.bannerData.to && (
                        <span>Vom <strong>{props.bannerData.from}</strong> bis <strong>{props.bannerData.to}</strong>. </span>
                    )}
                    {props.bannerData.returnDate && (
                        <span>Ab dem <strong>{props.bannerData.returnDate}</strong> sind wir wieder für Sie da. </span>
                    )}
                    {props.bannerData.emergency && <span>{props.bannerData.emergency}</span>}
                </div>
            </div>
            {props.bannerData.returnDate && (
                <div className="vacation-banner__dates">
                    <strong>Wiedereröffnung</strong>
                    {props.bannerData.returnDate}
                </div>
            )}
            <button
                className="vacation-banner__close"
                onClick={props.onClose}
                aria-label="Banner schließen"
            >✕
            </button>
        </div>
    );
}